"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.i18nInit = i18nInit;
exports.setI18nLocale = setI18nLocale;

var _q = _interopRequireDefault(require("q"));

var _createStandardI18nProvider = _interopRequireDefault(require("I18n/init/providers/createStandardI18nProvider"));

var _createAllI18nProvider = _interopRequireDefault(require("I18n/init/providers/createAllI18nProvider"));

var _en = _interopRequireDefault(require("i2l?query=sporks!../../lang/en.lyaml"));

var _en2 = _interopRequireDefault(require("i2l?query=sporks!quotes-ui-components/static/lang/en.lyaml"));

var _registerAllData = _interopRequireDefault(require("I18n/init/register/sync/registerAllData"));

require("I18n/init/data/currency");

require("I18n/init/data/baseLocales");

require("I18n/init/data/publicLocales");

require("I18n/init/data/allTimezones");

var _provider = null; // since you can preview quotes in all of our public languages they need all of their lang files,
// use a separate provider for that.

var _allProvider = null;

function getProvider() {
  if (!_provider) {
    _provider = (0, _createStandardI18nProvider.default)();
  }

  return _provider;
}

function getAllProvider() {
  if (!_allProvider) {
    _allProvider = (0, _createAllI18nProvider.default)();
  }

  return _allProvider;
}

function i18nInit() {
  var provider = getProvider();
  var allProvider = getAllProvider();
  return _q.default.Promise.all([provider.register(_en.default), allProvider.register(_en2.default), (0, _registerAllData.default)(provider), (0, _registerAllData.default)(allProvider)]);
}

function setI18nLocale() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      portal = _ref.portal,
      user = _ref.user;

  var provider = getProvider();
  var allProvider = getAllProvider();
  allProvider.setLocale({
    locale: user.locale,
    langEnabled: user.lang_enabled,
    timezone: portal.timezone
  });
  provider.setLocale({
    locale: user.locale,
    langEnabled: user.lang_enabled,
    timezone: portal.timezone
  });
}